
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/* @ts-self-types="./index.d.ts" */ let $e7016a9af9b25e86$export$2b646eea95309f00 = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';


let $cf399e049a9c4d34$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $cf399e049a9c4d34$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log2(alphabet.length - 1)) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = '';
        while(true){
            let bytes = getRandom(step);
            let j = step | 0;
            while(j--){
                id += alphabet[bytes[j] & mask] || '';
                if (id.length >= size) return id;
            }
        }
    };
};
let $cf399e049a9c4d34$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$cf399e049a9c4d34$export$a5cee9e955a615e5(alphabet, size | 0, $cf399e049a9c4d34$export$4385e60b38654f68);
let $cf399e049a9c4d34$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = '';
    let bytes = crypto.getRandomValues(new Uint8Array(size |= 0));
    while(size--)id += (0, $e7016a9af9b25e86$export$2b646eea95309f00)[bytes[size] & 63];
    return id;
};


function $c840ec8a99177096$export$2e2bcd8739ae039(array) {
    const item = array.map(({ name: name, country: country, birthYear: birthYear, deathYear: deathYear, style: style, image: image })=>{
        return `  <li id="${(0, $cf399e049a9c4d34$export$ac4959f4f1338dfc)(3)}">
                <img src="${image}">
                <h2>${name}</h2>
                <h3>${country}</h3>
                <p>${birthYear}</p>
                <p>${deathYear}</p>
                <p>${style}</p>
            </li>`;
    }).join("");
    return item;
}


var $356e4969a59f2337$exports = {};
$356e4969a59f2337$exports = JSON.parse('[{"image":"https://i.pinimg.com/originals/0a/e3/60/0ae360816748f01b50797ee053c0b7b5.jpg","name":"Vincent van Gogh","country":"Netherlands","birthYear":1853,"deathYear":1890,"style":"Post-Impressionism","famousWorks":["Starry Night","Sunflowers","The Bedroom"]},{"image":"https://tse4.mm.bing.net/th/id/OIP.E5PHMHoS0DEvYl-gjm_i1QHaKK?rs=1&pid=ImgDetMain&o=7&rm=3","name":"Pablo Picasso","country":"Spain","birthYear":1881,"deathYear":1973,"style":"Cubism","famousWorks":["Guernica","Les Demoiselles d\'Avignon","The Weeping Woman"]},{"image":"https://tse1.mm.bing.net/th/id/OIP.DtC3ATqwhnlc_X8KeBv7aAHaJg?rs=1&pid=ImgDetMain&o=7&rm=3","name":"Leonardo da Vinci","country":"Italy","birthYear":1452,"deathYear":1519,"style":"Renaissance","famousWorks":["Mona Lisa","The Last Supper","Vitruvian Man"]},{"image":"https://tse2.mm.bing.net/th/id/OIP.LbTmaWSjPH8tg1VzbQHJ8wHaKA?rs=1&pid=ImgDetMain&o=7&rm=3","name":"Claude Monet","country":"France","birthYear":1840,"deathYear":1926,"style":"Impressionism","famousWorks":["Water Lilies","Impression, Sunrise","Woman with a Parasol"]},{"image":"https://tse1.mm.bing.net/th/id/OIP.hvkaRN4jmFNubkwlqDmZYgHaJO?rs=1&pid=ImgDetMain&o=7&rm=3","name":"Salvador Dal\xed","country":"Spain","birthYear":1904,"deathYear":1989,"style":"Surrealism","famousWorks":["The Persistence of Memory","Swans Reflecting Elephants","Metamorphosis of Narcissus"]},{"image":"https://tse2.mm.bing.net/th/id/OIP.hgGeMiOTU-Ip1zfzysQIVAHaJ3?rs=1&pid=ImgDetMain&o=7&rm=3","name":"Frida Kahlo","country":"Mexico","birthYear":1907,"deathYear":1954,"style":"Surrealism / Folk Art","famousWorks":["The Two Fridas","Self-Portrait with Thorn Necklace","The Broken Column"]},{"image":"https://cdn.britannica.com/46/75046-050-0973B0E8/Michelangelo.jpg","name":"Michelangelo","country":"Italy","birthYear":1475,"deathYear":1564,"style":"Renaissance","famousWorks":["The Creation of Adam","David","Pieta"]},{"image":"https://tse4.mm.bing.net/th/id/OIP.vKfizNnZS9g-CIXh09iwkQHaHa?rs=1&pid=ImgDetMain&o=7&rm=3","name":"Rembrandt","country":"Netherlands","birthYear":1606,"deathYear":1669,"style":"Baroque","famousWorks":["The Night Watch","The Anatomy Lesson","Self-Portraits"]}]');


const $6f40c3a58f594b58$var$listRef = document.querySelector(".list");
$6f40c3a58f594b58$var$listRef.innerHTML = (0, $c840ec8a99177096$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($356e4969a59f2337$exports))));


//# sourceMappingURL=goit-tema6.51f7e1e0.js.map
